<template>
  <div class="analysis-selection">
    <div class="selection-content">
      <div class="header-section">
        <!-- <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          <span>Back to Database</span>
        </button> -->
        <h1 class="page-title">{{ moduleName }}</h1>
        <p class="page-subtitle">{{ moduleDescription }}</p>
      </div>

      <h2 class="section-title">Select Analysis Type</h2>

      <div class="cards-grid">
        <div class="analysis-card" @click="selectAnalysis('disease')">
          <div class="card-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <path d="M12 20 L12 44 C12 50 20 50 20 44 L20 20" stroke="#ef4444" stroke-width="2.5" fill="none" stroke-linecap="round"/>
              <path d="M44 20 L44 44 C44 50 52 50 52 44 L52 20" stroke="#ef4444" stroke-width="2.5" fill="none" stroke-linecap="round"/>
              <line x1="20" y1="32" x2="44" y2="32" stroke="#ef4444" stroke-width="2.5" stroke-linecap="round"/>
              <circle cx="16" cy="14" r="4" fill="#ef4444" opacity="0.8"/>
              <circle cx="48" cy="14" r="4" fill="#ef4444" opacity="0.8"/>
              <line x1="16" y1="18" x2="16" y2="20" stroke="#ef4444" stroke-width="2" opacity="0.6"/>
              <line x1="48" y1="18" x2="48" y2="20" stroke="#ef4444" stroke-width="2" opacity="0.6"/>
            </svg>
          </div>
          <div class="card-body">
            <h3 class="card-title">Disease Analysis</h3>
            <p class="card-desc">Explore associations between variables and disease outcomes with statistical evidence.</p>
            <span class="card-tag">Disease → Outcome</span>
          </div>
          <div class="card-arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>

        <div class="analysis-card" @click="selectAnalysis('metabolites')">
          <div class="card-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <circle cx="20" cy="28" r="8" stroke="#ef4444" stroke-width="2.5" fill="#ef4444" opacity="0.2"/>
              <circle cx="44" cy="28" r="8" stroke="#ef4444" stroke-width="2.5" fill="#ef4444" opacity="0.2"/>
              <circle cx="32" cy="46" r="8" stroke="#ef4444" stroke-width="2.5" fill="#ef4444" opacity="0.2"/>
              <line x1="26" y1="32" x2="38" y2="32" stroke="#ef4444" stroke-width="2" opacity="0.6"/>
              <line x1="24" y1="34" x2="28" y2="42" stroke="#ef4444" stroke-width="2" opacity="0.6"/>
              <line x1="40" y1="34" x2="36" y2="42" stroke="#ef4444" stroke-width="2" opacity="0.6"/>
              <circle cx="20" cy="16" r="3" fill="#ef4444" opacity="0.5"/>
              <line x1="20" y1="19" x2="20" y2="20" stroke="#ef4444" stroke-width="1.5" opacity="0.4"/>
              <circle cx="48" cy="18" r="2" fill="#ef4444" opacity="0.4"/>
              <circle cx="32" cy="14" r="2.5" fill="#ef4444" opacity="0.4"/>
              <line x1="34" y1="16" x2="38" y2="22" stroke="#ef4444" stroke-width="1" opacity="0.3"/>
            </svg>
          </div>
          <div class="card-body">
            <h3 class="card-title">Metabolites Analysis</h3>
            <p class="card-desc">Investigate metabolite-level associations and metabolic pathway evidence.</p>
            <span class="card-tag">Metabolite → Pathway</span>
          </div>
          <div class="card-arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>

        <div class="analysis-card" @click="selectAnalysis('mediation')">
          <div class="card-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <circle cx="14" cy="32" r="8" stroke="#ef4444" stroke-width="2.5" fill="#ef4444" opacity="0.15"/>
              <circle cx="50" cy="32" r="8" stroke="#ef4444" stroke-width="2.5" fill="#ef4444" opacity="0.15"/>
              <circle cx="32" cy="16" r="6" stroke="#ef4444" stroke-width="2" fill="#ef4444" opacity="0.25"/>
              <line x1="22" y1="28" x2="26" y2="20" stroke="#ef4444" stroke-width="2" stroke-linecap="round" opacity="0.7"/>
              <line x1="38" y1="20" x2="42" y2="28" stroke="#ef4444" stroke-width="2" stroke-linecap="round" opacity="0.7"/>
              <line x1="22" y1="32" x2="42" y2="32" stroke="#ef4444" stroke-width="2" stroke-dasharray="4 2" opacity="0.5"/>
              <text x="14" y="35" text-anchor="middle" font-size="7" fill="#ef4444" font-weight="600">X</text>
              <text x="32" y="19" text-anchor="middle" font-size="6" fill="#ef4444" font-weight="600">M</text>
              <text x="50" y="35" text-anchor="middle" font-size="7" fill="#ef4444" font-weight="600">Y</text>
            </svg>
          </div>
          <div class="card-body">
            <h3 class="card-title">Mediation Analysis</h3>
            <p class="card-desc">Analyze mediation effects: how intermediate variables mediate exposure-outcome relationships.</p>
            <span class="card-tag">X → M → Y</span>
          </div>
          <div class="card-arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalysisCardSelection',
  props: {
    moduleName: {
      type: String,
      required: true
    },
    moduleDescription: {
      type: String,
      default: ''
    },
    basePath: {
      type: String,
      required: true
    }
  },
  methods: {
    selectAnalysis(analysisType) {
      this.$router.push(`${this.basePath}/${analysisType}`)
    },
    goBack() {
      this.$router.push('/database')
    }
  }
}
</script>

<style lang="less" scoped>
.analysis-selection {
  min-height: 100%;
  position: relative;
  overflow: hidden;
}

.selection-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 64px);
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #991b1b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 0;
  margin-bottom: 16px;
  transition: opacity 0.2s;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    opacity: 0.7;
  }
}

.header-section {
  text-align: center;
  margin-bottom: 36px;
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.page-subtitle {
  font-size: 15px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  text-align: center;
  margin: 0 0 24px 0;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.analysis-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 28px 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(239, 68, 68, 0.1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-color: rgba(239, 68, 68, 0.3);
  }
}

.card-icon {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  background: rgba(254, 242, 242, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;

  svg {
    width: 48px;
    height: 48px;
  }
}

.card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 10px 0;
}

.card-desc {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 14px 0;
  line-height: 1.5;
}

.card-tag {
  display: inline-block;
  padding: 3px 10px;
  background: #fef2f2;
  color: #991b1b;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 12px;
}

.card-arrow {
  color: #ef4444;
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 900px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-title {
    font-size: 28px;
  }

  .selection-content {
    padding: 24px 16px;
  }
}
</style>
